// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewWindow {
  position: fixed;
  right: 310px;
  top: 140px;
}

.backgroundTile img {
  background: grey;
  border: solid darkblue 3px;
}

.previewAnim[backgroundImage="0"] {
  background: none;
}

/* None */
.form .toggle {
  display: none;
}

.preview {
  border: 1px solid black;
  width: 300px;
  height: 300px;
  position: absolute;
  left: 0;
  right: 0;
  top: 2em;
  bottom: 0;
  overflow: hidden;
}

.previewAnim {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  background-repeat: repeat !important;
  overflow: hidden;
}

.optotype {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 300px;
  font-weight: 800;
  /* The same as your div height */
}

@keyframes vertical {
  0% {
    background-position-y: 0px;
  }
  100% {
    background-position-y: 300px;
  }
}
@keyframes horizontal {
  0% {
    background-position-x: 0px;
  }
  100% {
    background-position-x: 300px;
  }
}
@keyframes lroscillate {
  0% {
    background-position-x: 0px;
  }
  25% {
    background-position-x: 150px;
  }
  50% {
    background-position-x: 0px;
  }
  75% {
    background-position-x: -150px;
  }
  100% {
    background-position-x: 0px;
  }
}
@keyframes udoscillate {
  0% {
    background-position-y: 0px;
  }
  25% {
    background-position-y: 150px;
  }
  50% {
    background-position-y: 0px;
  }
  75% {
    background-position-y: -150px;
  }
  100% {
    background-position-y: 0px;
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.rotate {
  animation-name: rotate;
  transform-origin: center;
  background-repeat: repeat !important;
  background-position: 50px 50px !important;
  width: 400px;
  height: 400px;
  left: -50px;
  top: -50px;
  /* background-size: cover !important; */
}

.lroscillate {
  animation-name: lroscillate;
}

.udoscillate {
  animation-name: udoscillate;
}

.vertical {
  animation-name: vertical;
}

.horizontal {
  animation-name: horizontal;
}

.slow {
  animation-duration: 10s;
}

.medium-slow {
  animation-duration: 5s;
}

.medium {
  animation-duration: 2s;
}

.medium-fast {
  animation-duration: 1.5s;
}

.fast {
  animation-duration: 1s;
}

.reversed {
  animation-direction: reverse;
}`, "",{"version":3,"sources":["webpack://./src/app/vestibular/vestibular-preview/vestibular-preview.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAGA,SAAA;AACA;EAAgB,aAAA;AAChB;;AA0CA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AAvCF;;AA0CA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,iCAAA;EACA,mCAAA;EACA,oCAAA;EAEA,gBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gCAAA;AAzCF;;AA4CA;EACE;IACE,0BAAA;EAzCF;EA2CA;IACE,4BAAA;EAzCF;AACF;AA4CA;EACE;IACE,0BAAA;EA1CF;EA4CA;IACE,4BAAA;EA1CF;AACF;AA6CA;EACE;IACE,0BAAA;EA3CF;EA6CA;IACE,4BAAA;EA3CF;EA6CA;IACE,0BAAA;EA3CF;EA6CA;IACE,6BAAA;EA3CF;EA6CA;IACE,0BAAA;EA3CF;AACF;AA8CA;EACE;IACE,0BAAA;EA5CF;EA8CA;IACE,4BAAA;EA5CF;EA8CA;IACE,0BAAA;EA5CF;EA8CA;IACE,6BAAA;EA5CF;EA8CA;IACE,0BAAA;EA5CF;AACF;AAiDA;EACE;IACE,uBAAA;EA/CF;EAkDA;IAAM,yBAAA;EA/CN;EAiDA;IACE,yBAAA;EA/CF;AACF;AAkDA;EACE,sBAAA;EACA,wBAAA;EACA,oCAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,uCAAA;AAhDF;;AAmDA;EACE,2BAAA;AAhDF;;AAmDA;EACE,2BAAA;AAhDF;;AAoDA;EACE,wBAAA;AAjDF;;AAoDA;EACE,0BAAA;AAjDF;;AAoDA;EACE,uBAAA;AAjDF;;AAoDA;EACE,sBAAA;AAjDF;;AAqDA;EACE,sBAAA;AAlDF;;AAqDA;EACE,wBAAA;AAlDF;;AAsDA;EACE,sBAAA;AAnDF;;AAsDA;EACE,4BAAA;AAnDF","sourcesContent":[".previewWindow {\n  position: fixed;\n  right: 310px;\n  top: 140px;\n}\n\n.backgroundTile img {\n  background: grey;\n  border: solid darkblue 3px;\n}\n\n.previewAnim[backgroundImage=\"0\"] {\n  background: none;\n}\n\n\n/* None */\n.form .toggle { display: none; }\n\n\n///* Vertical */\n//.form[backgroundImage=\"1\"]  .toggle.speed { display: flex; }\n//.form[backgroundImage=\"1\"]  .toggle.direction { display: flex; }\n//.form[backgroundImage=\"1\"]  .toggle .optokineticVertical { display: none; }\n//.form[backgroundImage=\"1\"]  .toggle .optokineticUDOscillate { display: none; }\n//.form[backgroundImage=\"1\"]  .toggle .optokineticRotate { display: none; }\n//.form[backgroundImage=\"1\"]  .toggle.stripeSize { display: flex; }\n//\n///* Horizontal */\n//.form[backgroundImage=\"2\"]  .toggle.speed { display: flex; }\n//.form[backgroundImage=\"2\"]  .toggle.direction { display: flex; }\n//.form[backgroundImage=\"2\"]  .toggle .optokineticHorizontal { display: none; }\n//.form[backgroundImage=\"2\"]  .toggle .optokineticLROscillate { display: none; }\n//.form[backgroundImage=\"2\"]  .toggle .optokineticRotate { display: none; }\n//.form[backgroundImage=\"2\"]  .toggle.stripeSize { display: flex; }\n//\n///* Checker */\n//.form[backgroundImage=\"3\"]  .toggle.speed { display: flex; }\n//.form[backgroundImage=\"3\"]  .toggle.direction { display: flex; }\n//.form[backgroundImage=\"3\"]  .toggle.size { display: flex; }\n//.form[backgroundImage=\"3\"]  .toggle .optokineticRotate { display: flex; }\n//\n///* Contrasting */\n//.form[backgroundImage=\"4\"]  .toggle.speed { display: flex; }\n//.form[backgroundImage=\"4\"]  .toggle.direction { display: flex; }\n//.form[backgroundImage=\"4\"]  .toggle.size { display: flex; }\n//.form[backgroundImage=\"4\"]  .toggle.contrast { display: flex; }\n//.form[backgroundImage=\"4\"]  .toggle .optokineticRotate { display: flex; }\n//\n///* Dots */\n//.form[backgroundImage=\"5\"]  .toggle.speed { display: flex; }\n//.form[backgroundImage=\"5\"]  .toggle.direction { display: flex; }\n//.form[backgroundImage=\"5\"]  .toggle .optokineticHorizontal { display: flex; }\n//.form[backgroundImage=\"5\"]  .toggle .optokineticVertical { display: flex; }\n//.form[backgroundImage=\"5\"]  .toggle .optokineticLROscillate { display: flex; }\n//.form[backgroundImage=\"5\"]  .toggle .optokineticUDOscillate { display: flex; }\n//.form[backgroundImage=\"4\"]  .toggle .optokineticRotate { display: flex; }\n\n\n\n.preview {\n  border: 1px solid black;\n  width: 300px;\n  height: 300px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 2em;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.previewAnim {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  background-repeat: repeat !important;\n\n  overflow: hidden;\n}\n\n.optotype {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 300px;\n  font-weight: 800;\n\n  /* The same as your div height */\n}\n\n@keyframes vertical {\n  0% {\n    background-position-y: 0px;\n  }\n  100% {\n    background-position-y: 300px;\n  }\n}\n\n@keyframes horizontal {\n  0% {\n    background-position-x: 0px;\n  }\n  100% {\n    background-position-x: 300px;\n  }\n}\n\n@keyframes lroscillate {\n  0% {\n    background-position-x: 0px;\n  }\n  25% {\n    background-position-x: 150px;\n  }\n  50% {\n    background-position-x: 0px;\n  }\n  75% {\n    background-position-x: -150px;\n  }\n  100% {\n    background-position-x: 0px;\n  }\n}\n\n@keyframes udoscillate {\n  0% {\n    background-position-y: 0px;\n  }\n  25% {\n    background-position-y: 150px;\n  }\n  50% {\n    background-position-y: 0px;\n  }\n  75% {\n    background-position-y: -150px;\n  }\n  100% {\n    background-position-y: 0px;\n  }\n}\n\n\n\n@keyframes rotate {\n  0% {\n    transform: rotate( 0deg );\n  }\n\n  50% { transform: rotate( 180deg ); }\n\n  100% {\n    transform: rotate(359deg);\n  }\n}\n\n.rotate {\n  animation-name: rotate;\n  transform-origin: center;\n  background-repeat: repeat !important;\n  background-position: 50px 50px !important;\n  width: 400px;\n  height: 400px;\n  left: -50px;\n  top: -50px;\n  /* background-size: cover !important; */\n}\n\n.lroscillate {\n  animation-name: lroscillate;\n}\n\n.udoscillate {\n  animation-name: udoscillate;\n}\n\n\n.vertical {\n  animation-name: vertical;\n}\n\n.horizontal {\n  animation-name: horizontal;\n}\n\n.slow {\n  animation-duration: 10s;\n}\n\n.medium-slow {\n  animation-duration: 5s;\n}\n\n\n.medium {\n  animation-duration: 2s;\n}\n\n.medium-fast {\n  animation-duration: 1.5s;\n}\n\n\n.fast {\n  animation-duration: 1s;\n}\n\n.reversed {\n  animation-direction: reverse;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
